<template>
    <div class="about-section bg-off-white pt-100 pb-70 bg-white">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 pb-30">
                    <div class="about-section-item about-item-details">
                        <div class="section-title section-title-left text-start">
                            <h2>{{ $t('common.sections.aboutReverse2.title') }}</h2>
                        </div>
                        <div class="about-content">
                            <p>{{ $t('common.sections.aboutReverse2.description') }}</p>
                            <router-link to="/contact" class="btn main-btn">{{ $t('common.buttons.contact') }}</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 pb-30">
                    <div class="about-section-item about-item-image text-center">
                        <img v-lazy="$ossImg(localizedImg('home-about/about-4.png'))" alt="shape">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import localizedImageMixin from '@/mixins/localizedImageMixin'

export default {
    name: 'AboutReverse',
    mixins: [localizedImageMixin]
}
</script>

<style scoped>
.main-btn {
    background: linear-gradient(90deg, #0B71FA 0%, #29ABFD 100%);
    transition: all 0.5s ease-in-out;
}

.main-btn:hover {
    background: linear-gradient(90deg, #0B71FA 0%, #FF94C8 100%);
}
</style>
